import { useEffect, useState } from 'react';

/** Phone-width viewports (below the 768px tablet breakpoint). */
export const MOBILE_QUERY = '(max-width: 767px)';

const matches = (query) =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false;

/**
 * useMediaQuery — true while `query` matches, updating on resize and
 * rotation. Returns false where matchMedia is unavailable (jsdom).
 */
export function useMediaQuery(query) {
  const [match, setMatch] = useState(() => matches(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const list = window.matchMedia(query);
    const onChange = () => setMatch(list.matches);
    onChange();
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return match;
}

export function useIsMobile() {
  return useMediaQuery(MOBILE_QUERY);
}
